import { apiUrls } from 'consts'
import { useEffect } from 'react'
import loadRecord from './../utils/loadRecord'
import getAll from 'utils/getAll'

interface useInitProps {
  getValues: Function
  id: string | undefined
  reset: Function
  setDataLoaded: Function
  setInactiveMessage: Function
  setShowOverlay: Function
  currentCustomer: {} | null
  setDefaultHomeUrl: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    // fetch the page if edit

    let defaultHomeUrl: string = ''
    const defaultHomeUrlPromise = getAll(apiUrls.actionGetAppUrl).then((data) => {
      defaultHomeUrl = data
    })

    if (props.id !== undefined) {
      loadRecord(apiUrls.customers, props.id).then((data) => {
        const inactiveMessage = data.inactive_message === null ? '' : data.inactive_message
        props.setInactiveMessage(inactiveMessage)
        props.reset(data)

        Promise.all([defaultHomeUrlPromise]).then(() => {
          props.setDefaultHomeUrl(defaultHomeUrl)
          props.setDataLoaded(true)
          props.setShowOverlay(false)
        })
      })
    } else {

      Promise.all([defaultHomeUrlPromise]).then(() => {
        props.setDefaultHomeUrl(defaultHomeUrl)
        props.setDataLoaded(true)
        props.setShowOverlay(false)
      })
    }
  }, [props.currentCustomer])
}

export default useInit
